module.exports = __webpack_public_path__ + "img/BV.d91702a1.svg";